import { aqua, gray3 } from 'assets/stylesheets/base/_colors';
import Generator from './generator';

export default class ActivationBarGenerator extends Generator {
  static _barChartConfig = {
    yAxis: 1,
    type: 'column',
    stacking: null,
    customTags: ['site_activation'],
  };

  _getActivationSeriesData(objectArray) {
    const baselinePlanKey = 'origPlanSitesActivatedCum';
    const currentPlanKey = 'currPlanSitesActivatedCum';
    const actualPlanKey = 'actualSitesActivatedCum';

    const activationSeriesData = {
      baselinePlan: this._getSeriesData(objectArray, baselinePlanKey),
      currentPlan: this._getSeriesData(objectArray, currentPlanKey),
      actual: this._getSeriesData(objectArray, actualPlanKey),
    };
    return activationSeriesData;
  }

  getSeries(objectArray) {
    const columnSeriesData = this._getActivationSeriesData(objectArray);
    // E2R1 Baseline Reactivation
    // const baselinePlanSeries = {
    //   name: 'Activations (Baseline)',
    //   id: 'forecastedSiteActivation',
    //   data: columnSeriesData.baselinePlan,
    //   color: gray4,
    //   ...ActivationBarGenerator._barChartConfig,
    // };

    const currentPlanSeries = {
      name: 'Activations (Current Plan)',
      id: 'currentSiteActivation',
      data: columnSeriesData.currentPlan,
      color: gray3,
      zIndex: 3,
      ...ActivationBarGenerator._barChartConfig,
    };

    const actualPlanSeries = {
      name: 'Activations (Actual)',
      id: 'actualSiteActivation',
      data: columnSeriesData.actual,
      color: aqua,
      zIndex: 3,
      ...ActivationBarGenerator._barChartConfig,
    };

    const activationSeries = [
      // E2R1 Baseline Reactivation
      // baselinePlanSeries,
      currentPlanSeries,
      actualPlanSeries,
    ];

    return activationSeries;
  }
}
